import { Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';

export enum DialogInfoType {
  IMPORT = 'import',
  UPDATE = 'update',
}

export type DialogInfoProps = {
  type: DialogInfoType;
};

export const DialogInfo = ({ type }: DialogInfoProps) => {
  return (
    <>
      {type === DialogInfoType.IMPORT && (
        <>
          <Typography variant="body2" sx={{ color: 'text.secondary' }}>
            <FormattedMessage
              id="upload.dialog.info.1"
              defaultMessage="Pro úspěšné nahrání souboru musí CSV obsahovat sloupec ipsosId a alespoň jeden sloupec s telefonním číslem (Telephonenumber1...)."
            />
          </Typography>
        </>
      )}
      <Typography variant="body2" sx={{ color: 'text.secondary' }}>
        <FormattedMessage
          id="upload.dialog.info.2"
          defaultMessage="Názvy sloupců musí být bez diakritiky a nesmí se opakovat."
        />
      </Typography>

      <Typography variant="body2" sx={{ color: 'text.secondary' }}>
        <FormattedMessage id="upload.dialog.info.3" defaultMessage="Hodnoty ipsosId musí být vyplněné a jedinečné." />
      </Typography>
    </>
  );
};
